// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"6ab8479b","17":"cd2b9e24","39":"2bb44462","40":"8b7dff6f","93":"f0e3526d","253":"24315a0b","407":"8fd0f583","464":"8a999a83","520":"aa091b0a","611":"8a53a538","647":"a8f0fbaf","659":"e279e9a0","723":"ff5efeff","932":"41796e30","940":"da8c09c3"}[chunkId] + ".chunk.js";
};